import { render } from "./PurchaseCredits.vue?vue&type=template&id=355be373&scoped=true&lang=html"
import script from "./PurchaseCredits.vue?vue&type=script&lang=js"
export * from "./PurchaseCredits.vue?vue&type=script&lang=js"

import "./PurchaseCredits.vue?vue&type=style&index=0&id=355be373&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355be373"]])

export default __exports__